{
  "title": "新手上路：學生／參賽者第一次使用指南",
  "description": "從取得競賽存取權限到查看結果，快速了解學生／參賽者在 NAPAICP 上完整的第一次使用流程。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "讀完後，您會知道如何取得競賽存取權限、組隊、填寫報名表單、視需要完成資格驗證、準備並正式提交作品，以及之後到哪裡查看結果。",
  "roleNote": "學生／參賽者",
  "prerequisites": [
    "已有可登入的 Email 帳號（或已完成註冊並驗證 Email）",
    "已找到想參加的競賽公開頁面，或已收到隊伍邀請連結"
  ],
  "pathLabel": "競賽公開頁面或隊伍邀請連結",
  "steps": [
    {
      "title": "1. 取得競賽存取權限",
      "description": "未登入即可在首頁或競賽列表瀏覽公開中的競賽，確定符合資格後登入報名，這是自助報名的方式；另一種方式是透過隊長分享的邀請連結，以自己的帳號登入並開啟連結加入既有隊伍。兩種方式都需要先登入且完成 Email 驗證。"
    },
    {
      "title": "2. 建立或加入隊伍",
      "description": "建立隊伍即成為隊長，可產生邀請連結分享給隊員；或使用隊長提供的連結加入既有隊伍。同一場競賽中，每個帳號最多只能有一個有效隊伍身分。"
    },
    {
      "title": "3. 填寫報名表單",
      "description": "登入且在報名開放期間內，依競賽要求填寫報名表單。表單會在您填寫時自動儲存；系統只在所有必填欄位都已填妥時才會儲存，儲存成功即視為報名已送出，您也可以按下「確認並完成報名」立即完成。必填的勾選框（例如「團隊聲明」）必須勾選。若之後報名資料顯示「需補填」，請開啟報名資料補上缺少的欄位。"
    },
    {
      "title": "4. 視需要完成學生資格驗證",
      "description": "若該場競賽開啟了學生資格驗證政策，「參賽資訊」摘要區塊會另外顯示團隊資格驗證完成度磚，點擊可前往「學生資格驗證」頁上傳在學證明。這裡最重要的一件事：資格驗證狀態完全不會影響報名是否完成，即使尚未通過驗證，「確認並完成報名」也不會被擋下；報名表單儲存這個動作永遠不會檢查資格驗證結果，兩者互不影響。"
    },
    {
      "title": "5. 準備並正式提交作品",
      "description": "填寫作品繳交表、上傳檔案都只是草稿狀態，不等於已經完成繳交。確認內容與檔案都正確後，先點選「標記為就緒」，再點擊「正式提交」，作品才會被視為正式參賽版本，主辦方與評審才看得到。"
    },
    {
      "title": "6. 之後到哪裡查看狀態與結果",
      "description": "提交後可隨時回到「我的競賽」查看目前所屬隊伍、報名與作品狀態。結果公布後，若主辦方已開放參賽者查看範圍，可在「我的結果」查看自己隊伍的分數、名次與獎項等第，看不到其他隊伍的資料。"
    }
  ],
  "afterward": [
    "您可以隨時在「我的競賽」查看目前所屬隊伍、報名狀態與作品狀態",
    "若該場競賽要求資格驗證，可在「學生資格驗證」頁隨時查看目前審核進度",
    "作品正式提交後，需請主辦方協助解鎖或退回修正才能再次編輯"
  ],
  "nextSteps": "完整規則與每個步驟的細節請見「操作手冊：參賽者」；若需要上傳或更新在學證明，請見「如何上傳學生資格驗證證明」。",
  "faq": [
    {
      "q": "資格驗證還沒通過，可以先完成報名嗎？",
      "a": "可以。資格驗證狀態不會影響報名是否完成，即使尚未通過驗證，「確認並完成報名」也不會被擋下；儲存報名表單這個動作永遠不會檢查資格驗證結果，兩者互不影響，之後再補齊驗證即可。"
    },
    {
      "q": "我應該先組隊還是先填報名表單？",
      "a": "兩者沒有強制先後順序，但通常會先確認自己是否已有隊伍身分（建立或加入），再前往報名表單填寫；報名表單於報名期間內可重複修改與儲存。"
    },
    {
      "q": "上傳完作品檔案，是不是就算正式提交了？",
      "a": "不是。上傳檔案只是把檔案放進草稿，一定要先「標記為就緒」再點擊「正式提交」，作品才會真正送交競賽，主辦方與評審才看得到。"
    }
  ]
}
